<ion-select [disabled]="isDisabled()">
  <ion-select-option value="AT">AT</ion-select-option>
  <ion-select-option value="BE">BE</ion-select-option>
  <ion-select-option value="BG">BG</ion-select-option>
  <ion-select-option value="CY">CY</ion-select-option>
  <ion-select-option value="CZ">CZ</ion-select-option>
  <ion-select-option value="DE">DE</ion-select-option>
  <ion-select-option value="DK">DK</ion-select-option>
  <ion-select-option value="EE">EE</ion-select-option>
  <ion-select-option value="EL">EL</ion-select-option>
  <ion-select-option value="ES">ES</ion-select-option>
  <ion-select-option value="FI">FI</ion-select-option>
  <ion-select-option value="FR">FR</ion-select-option>
  <ion-select-option value="GB">GB</ion-select-option>
  <ion-select-option value="HR">HR</ion-select-option>
  <ion-select-option value="HR">HR</ion-select-option>
  <ion-select-option value="HU">HU</ion-select-option>
  <ion-select-option value="IE">IE</ion-select-option>
  <ion-select-option value="IT">IT</ion-select-option>
  <ion-select-option value="LT">LT</ion-select-option>
  <ion-select-option value="LU">LU</ion-select-option>
  <ion-select-option value="LV">LV</ion-select-option>
  <ion-select-option value="MT">MT</ion-select-option>
  <ion-select-option value="NL">NL</ion-select-option>
  <ion-select-option value="PL">PL</ion-select-option>
  <ion-select-option value="PT">PT</ion-select-option>
  <ion-select-option value="RO">RO</ion-select-option>
  <ion-select-option value="SE">SE</ion-select-option>
  <ion-select-option value="SI">SI</ion-select-option>
  <ion-select-option value="SK">SK</ion-select-option>
</ion-select>

<ion-input
  [disabled]="isDisabled()"
  [value]="value()"
  (input)="onChange($event)"
></ion-input>
